export const getters = {
    getIndiceList: state => state.indiceList,
    getIndiceRanking: state => state.indiceRanking,
    getIndiceFollowing: state => state.indiceFollowing,
    getIndiceNav: state => state.indiceNav,
    getIndiceQuote: state => state.indiceQuote,
    getIndiceShareToFriend: state => state.indiceNavShare,
    getIndiceTimestamp1D: state => state.indiceTimestamp1D
}
  